import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import {
  CreateCrtPeriodDetailsDialog,
  getDefaultImportPeriod,
} from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { ipAccrualsSearchSchema, useCreateIpAccrual } from '@/hooks/queries/crt/useIpAccruals'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import IpAccrualsDataTable from './-components/IpAccrualsDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/customer-investments/insights/ip-accruals/',
)({
  component: RouteComponent,
  validateSearch: (search) => ipAccrualsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateIpAccrual({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('ipAccruals.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_ip_accruals_create']}>
          <CreateCrtPeriodDetailsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            triggerLabel={t('ipAccruals.createButton')}
            title={t('createIpAccrualDialog.title')}
            nameLabel={t('createIpAccrualDialog.name.label')}
            namePlaceholder={t('createIpAccrualDialog.name.placeholder')}
            isPending={isPending}
            crtPeriodLabel={t('period')}
            defaultCrtPeriod={getDefaultImportPeriod()}
            onSubmit={({ name, description, crtPeriod }) =>
              mutate({ name, description, period: crtPeriod })
            }
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('ipAccruals.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <IpAccrualsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
